module.exports = __webpack_public_path__ + "media/images/platforms/playstation/connect-b434e361be58ccee77f6b957f82e0dca.png";